// extracted by mini-css-extract-plugin
export default {"userpic":"Avatar_userpic__5cUZ9","container":"Avatar_container__Wn20d","avatar":"Avatar_avatar__tc3lo","delete":"Avatar_delete__IwYwW"};